
import http from '@/components/services/http-common';
import moment from 'moment/moment';
export default {
    props:["value", "item", "employee"],
    watch:{
        employee(val) {
            console.log("has employee");
        },
        value: {
            handler(val){
                if(val)
                {
                    if(this.isEdit)
                        this.fetch();
                }
                else{
                    this.close();
                }
            }
        },

    },
    computed: {
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
        isEdit() {
            return !!this.item;
        }
    },
    data() {
        return {
            ROOT_URL: "quitRequests/",

            isValid: true,
            fetchData: false,
            viewImageDialog: false,
            currentImageUrl: '',
            form: {
                "id": null,
                "code": "",
                "name": "",
                "acceptBy1": "",
                "acceptBy2": "",
                "acceptBy3": null,
                "acceptBy1Name": null,
                "acceptBy2Name": "",
                "acceptBy3Name": null,
                "status": 0,
                "quitDate": "",
                "sendDate": "",
                "l1Accept": 0,
                "l2Accept": 0,
                "hrAccept": 0,
                "quitReason": "",
                "note": null,
                "hrNote": "",
                "l1Note": "",
                "l2Note": "",
                "quitTypeCode": "",
                "quitTypeName": ""
            },
            defaultForm:{
                "id": null,
                "code": "",
                "name": "",
                "acceptBy1": "",
                "acceptBy2": "",
                "acceptBy3": null,
                "acceptBy1Name": null,
                "acceptBy2Name": "",
                "acceptBy3Name": null,
                "status": 0,
                "quitDate": "",
                "sendDate": "",
                "l1Accept": 0,
                "l2Accept": 0,
                "hrAccept": 0,
                "quitReason": "",
                "note": null,
                "hrNote": "",
                "l1Note": "",
                "l2Note": "",
                "quitTypeCode": "",
                "quitTypeName": ""
            },
            quitReasons: [
                "Khác",
            ]
        }
    },
    methods: {
        viewImage(url) {
            this.currentImageUrl = url;
            this.viewImageDialog = true;
        },
        fetch(employee = false){
            this.fetchData =true;
            return http.get(this.ROOT_URL+"manager/"+this.item.code).then(res => {
                this.form = {...res.data.data};
                this.fetchData =false;
            })
        },
        saveData() {
            this.$refs.form.validate();
            if(this.isValid)
            {
                if(!this.isEdit){
                    return http.post(this.ROOT_URL, this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }else {
                    return http.put(this.ROOT_URL+ this.item.code, this.form).then(res =>{
                        this.$emit("fetch");
                        this.dialog = false;
                    })
                }
            }
        },
        
        confirm() {
            return http.get(this.ROOT_URL+"hr/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },

        confirmManager1() {
            return http.get(this.ROOT_URL+"manager/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },
        
        denyManager1() {
            return http.get(this.ROOT_URL+"manager/deny/"+this.item.code, {
                params: {
                    note: this.form.note
                }
            }).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },
        
        confirmManager2() {
            return http.get(this.ROOT_URL+"manager2/accept/"+this.item.code).then(() => {
                this.$emit("fetch");
                this.dialog = false;
            })
        },

        close(){
            this.form = Object.assign({}, this.defaultForm);
            this.$refs.form.resetValidation();
            this.fetchData=false;
        }
    },
    created() {
    }
}